import { createContext, useContext } from 'react'

/** The open session's workspace discount in percent; provided by `WorkspaceDiscountProvider`. */
export const WorkspaceDiscountContext = createContext(0)

/** The workspace discount in percent; 0 outside the provider or without a discount. */
export const useWorkspaceDiscount = (): number => useContext(WorkspaceDiscountContext)
